import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Lang, LangRS, LanguageTypes } from '../../models/lang.models';
import { TranslateService } from '@ngx-translate/core';
import { map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  constructor(private http: HttpClient, private translateService: TranslateService) { }

  // getAll() {
  //   return this.http.get<LangRS>(`${environment.URL_API}/langs`).pipe(
  //     map((langRs: LangRS) => {
  //       const langs = langRs.langs;

  //       Object.keys(LanguageTypes).map((key: string) => {
  //         const lang = langs.find((lang: Lang) => lang.langId === key);
  //         if (lang && lang.active) {
  //           const { description, ...langDTO } = lang;
  //           return {
  //             ...langDTO,
  //             description: this.translateService.instant(LanguageTypes[key as keyof typeof LanguageTypes])
  //           };
  //         }
  //         return null;
  //       }).filter(lang => lang !== null)
  //     }

  //     )
  //   );
  // }
  
  getAll() {
    return this.http.get<LangRS>(`${environment.URL_API}/langs`).pipe(
      map((langRs: LangRS) => {
        return langRs.langs;
      })
    );
  }
}
